module.exports = __webpack_public_path__ + "static/media/BLUSH_6700.5f46c255.jpg";